import { type FC } from "react";
import { useReportLastUpdatedQuery } from "./useReportLastUpdatedQuery";
import { useReportingFormatWithTimeZone } from "hooks/useReportingFormatWithTimeZone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import styles from "./ReportLastUpdated.module.scss";

export const ReportLastUpdated: FC = () => {
  const { isSuccess, data } = useReportLastUpdatedQuery();
  const formatDateTime = useReportingFormatWithTimeZone();

  if (!isSuccess || !data?.LastUpdated) {
    return null;
  }
  const date = formatDateTime(data.LastUpdated);

  return (
    <div className={styles.root}>
      <FontAwesomeIcon icon={faCircleCheck} className={styles.icon} />
      <span className={styles.label}>Last updated:</span>
      <span className={styles.timestamp}> {date}</span>
    </div>
  );
};
